import React from "react"
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap"
import classnames from "classnames"

export const FormModal = ({
  isOpen,
  toggle: closeModal,
  currentPrice,
  validation,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={closeModal} size="md">
      <ModalHeader toggle={closeModal} tag="h4">
        {!!currentPrice ? "Edytuj cenę" : "Dodaj cenę"}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row>
            <Col xs={12}>
              <Nav tabs className="nav-tabs-custom nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: true,
                    })}
                  >
                    <span className="d-block d-sm-none">
                      <i className="fas fa-home"></i>
                    </span>
                    <span className="d-none d-sm-block">
                      Cena do formy dostawy
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={"1"} className="p-3 text-muted">
                <TabPane tabId="1">
                  <Row>
                    <Col lg="12 mb-3">
                      <Label className="form-label">Cena</Label>
                      <Input
                        name="price"
                        type="number"
                        step="0.01"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.price || ""}
                        invalid={
                          validation.touched.price && validation.errors.price
                            ? true
                            : false
                        }
                      />
                      {validation.touched.price && validation.errors.price ? (
                        <FormFeedback type="invalid">
                          {validation.errors.price}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12 mb-3">
                      <Label className="form-label">Waga od:</Label>
                      <Input
                        name="weight_from"
                        type="number"
                        step="0.01"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.weight_from || ""}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12 mb-3">
                      <Label className="form-label">Waga do:</Label>
                      <Input
                        name="weight_to"
                        type="number"
                        step="0.01"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.weight_to || ""}
                      />
                    </Col>
                  </Row>
                  <Button type="submit" color="primary">
                    Zapisz
                  </Button>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}
